import React from 'react';
import PrintDreLocacao from './PrintDreLocacao';
import PrintDreDividendos from './PrintDreDividendos';

const PrintDre = () => {
    const modeloDeContrato = localStorage.getItem('modelo_negocio');
    return modeloDeContrato == 'locacao' ? <PrintDreLocacao /> : <PrintDreDividendos />;
}

export default PrintDre;